<template>
  <Home>
    <p>Page not found</p>
  </Home>
</template>

<script>
  import Home from '../Home.vue'
  export default {
    components: {
      Home
    }
  }
</script>



// WEBPACK FOOTER //
// src/secure/components/404.vue